import React from 'react';
import { ContentCard } from '../style';
import PropTypes from 'prop-types';

const SellaInformation = ({ order }) => {
  const { partner } = order;
  return (
    <ContentCard>
      <div className="header">Sella Information</div>
      <div className="body">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div>
            <p className="title"> Store Location</p>
            <p className="sub">
              {' '}
              {partner?.street_address}, {partner?.state}
            </p>
          </div>

          <div>
            <p className="title"> Phone Number</p>
            <p className="sub"> {partner?.phone}</p>
          </div>
        </div>
      </div>
    </ContentCard>
  );
};

export default SellaInformation;

SellaInformation.propTypes = {
  order: PropTypes.object.isRequired,
};
